export default __webpack_public_path__ + "static/media/article02.55243ce7.md";